export const ASYNC_SEARCH_PER_PAGE = '20';
export const ASYNC_SEARCH_CURRENT_PAGE = '1';
export const AVOID_PAGINATION_PER_PAGE = '999';
export const NUMBER_ROUND_DECIMAL = 3;
